/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as i from "react";
import e from "prop-types";
const s = class s extends i.Component {
  /**
   * @hidden
   */
  render() {
    return null;
  }
};
s.propTypes = {
  text: e.string,
  icon: e.string,
  iconClass: e.string,
  imageUrl: e.string,
  selected: e.bool,
  disabled: e.bool,
  render: e.any
};
let r = s;
export {
  r as DropDownButtonItem
};
